import {
	FrontendAnalystCustomGroup,
	FrontendCompanyTestCategory,
	FrontendCompanyWithAdditionalInfomation,
} from "node-library/dist/portal";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
	CustomCheckbox,
	CustomDropdown,
} from "../../../../../common-components/inputs";

interface Props {
	company: FrontendCompanyWithAdditionalInfomation;
	newGroupId: string;
	customGroups: Array<FrontendAnalystCustomGroup>;
	permissionState: FrontendAnalystCustomGroup;
	toggleCheckboxOption: (id: string) => void;
	toggleOtherTestOption: (id: string) => void;
	changeCustomGroup: (groupId: string) => void;
}
export default function EditAnalystPermissionModalContent(props: Props) {
	const { t: translation } = useTranslation();
	const {
		company,
		newGroupId,
		customGroups,
		permissionState,
		toggleCheckboxOption,
		toggleOtherTestOption,
		changeCustomGroup,
	} = props;

	const [selectedCategoryId, setSelectedCategoryId] = useState<string>(
		company.companyTestCategories[0].testCategoryId
	);

	const selectedCategory: FrontendCompanyTestCategory =
		company.companyTestCategories.find((category) => {
			return category.testCategoryId == selectedCategoryId;
		}) as FrontendCompanyTestCategory;

	const sortedBatchTypes = selectedCategory.batchTypes.sort((a, b) => {
		// First, sort by testCategoryId
		const categoryCompare = a.testGroupNodeId.localeCompare(b.testGroupNodeId);
		if (categoryCompare !== 0) return categoryCompare;

		// If testCategoryId is the same, sort by batchName
		return a.batchName.localeCompare(b.batchName);
	});
	const permissionFields = sortedBatchTypes.map((batchType) => {
		return {
			id: batchType.batchTypeId,
			title: batchType.batchName,
			value: batchType.batchTypeId,
		};
	});

	const otherTestEnabled: boolean =
		permissionState.testCategoryOtherTestPermissions.includes(
			selectedCategoryId
		);

	const permissionCheckboxes = permissionFields
		.map((field) => {
			const selected: boolean = permissionState.permittedBatchIds.includes(
				field.value
			);
			return (
				<div key={field.id}>
					<CustomCheckbox
						className={`test-option-checkbox ${
							selected && "test-option-checkbox-checked"
						}`}
						label={field.title}
						checked={selected}
						setChecked={() => toggleCheckboxOption(field.value)}
					/>
				</div>
			);
		})
		.concat([
			<div key="other-tests">
				<CustomCheckbox
					className={`test-option-checkbox ${
						otherTestEnabled && "test-option-checkbox-checked"
					}`}
					label={translation("Additionaltests")}
					checked={otherTestEnabled}
					setChecked={() => toggleOtherTestOption(selectedCategoryId)}
				/>
			</div>,
		]);

	const categoryDropdownOptions: Array<{
		title: string;
		value: string;
		renderValue?: string;
	}> = company.companyTestCategories.map((category) => ({
		title: category.testCategoryName,
		value: category.testCategoryId,
	}));

	const groupDropdownOptions: Array<{
		title: string;
		value: string;
		renderValue?: string;
	}> = customGroups.map((group) => ({
		title: group.groupName,
		value: group.groupId,
	}));

	if (
		!customGroups.find((group) => {
			return group.groupId == newGroupId;
		})
	) {
		groupDropdownOptions.push({
			title: translation("Custom"),
			value: newGroupId,
			renderValue: translation("Custom"),
		});
	}
	return (
		<div className="registration-input-content">
			<CustomDropdown
				id="category-dropdown"
				label={translation("TestCategory")}
				options={categoryDropdownOptions}
				value={selectedCategoryId}
				setValue={setSelectedCategoryId}
				displayEmpty
			/>
			<CustomDropdown
				id="user-group-dropdown"
				label={translation("Group")}
				options={groupDropdownOptions}
				value={permissionState.groupId}
				setValue={(value) => changeCustomGroup(value)}
				displayEmpty
			/>
			<div className="test-options-container">{permissionCheckboxes}</div>
		</div>
	);
}
